import { themeBalham } from 'ag-grid-community'

export default themeBalham
